import {
  CreateCustomInsightRequest,
  CreateCustomInsightResponse,
  GetCustomInsightsResponse,
  UpdateCustomInsightRequest,
  UpdateCustomInsightResponse,
  DeleteCustomInsightRequest,
  DeleteCustomInsightResponse,
} from 'src/types/insight-builder'
import { BaseClient } from 'src/common-services/clients/base-client'

export class CustomInsightsClient extends BaseClient {
  createCustomInsight(request: Omit<CreateCustomInsightRequest, 'userId'>): Promise<CreateCustomInsightResponse> {
    return this.call<CreateCustomInsightResponse>('/custom-insights', 'POST', { data: request })
  }
  getCustomInsights(): Promise<GetCustomInsightsResponse> {
    return this.call<GetCustomInsightsResponse>(`/custom-insights`, 'GET')
  }
  getCustomInsightsByUserId(userId: string): Promise<GetCustomInsightsResponse> {
    return this.call<GetCustomInsightsResponse>(`/custom-insights/user/${userId}`, 'GET')
  }
  updateCustomInsight(request: UpdateCustomInsightRequest): Promise<UpdateCustomInsightResponse> {
    return this.call<UpdateCustomInsightResponse>(`/custom-insights/${request.id}`, 'PUT', { data: request })
  }
  deleteCustomInsight(request: DeleteCustomInsightRequest): Promise<DeleteCustomInsightResponse> {
    return this.call<DeleteCustomInsightResponse>(`/custom-insights/${request.id}`, 'DELETE', { data: request })
  }
  copyCustomInsightToUser(request: { insightId: string; email: string }): Promise<boolean> {
    return this.call<boolean>(`/custom-insights/copy`, 'POST', { data: request })
  }
}
